import { render, staticRenderFns } from "./ContractsWorkersPilver.vue?vue&type=template&id=1b08fd84&"
import script from "./ContractsWorkersPilver.vue?vue&type=script&lang=js&"
export * from "./ContractsWorkersPilver.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports